<template>
  <b-container class="reserver">
    <h1 class="titre">Réservez votre trajet</h1>
    <h2 class="accroche">
      Besoin de vous déplacer en dehors des heures de passage de la ligne Express ? Il vous suffit de réserver votre
      horaire de passage par téléphone au <a class="telephone" href="tel:0387390818">03 87 39 08 18</a>
      de 9h à 12h et de 14h à 19h.
    </h2>

    <div class="row bloc_comment_ca_marche">
      <div class="col-md-6 col-12 etape">
        <i class="icone fas fa-phone-volume fa-5x"></i>
        <h2 class="titre_etape">1. Je réserve</h2>
        <span class="texte_etape">
          Directement par téléphone au <a class="lien" href="tel:0387390818">03 87 39 08 18</a>.
          Réservation la veille jusqu’à 17h pour un départ prévu le
          lendemain matin.
        </span>
      </div>
      <div class="col-md-6 col-12 etape">
        <i class="icone fas fa-map-signs fa-5x"></i>
        <h2 class="titre_etape">2. Mon trajet</h2>
        <span class="texte_etape">
          J’indique le numéro du service, les arrêts de départ et d’arrivée ainsi que l’horaire de départ souhaité en
          choisissant sur la <router-link class="lien" :to="{name: 'Horaires'}">fiche horaire dédiée</router-link>.
          Ma réservation sera confirmée par téléphone.
        </span>
      </div>
      <div class="col-12 etape">
        <i class="icone fas fa-bus-alt fa-5x"></i>
        <h2 class="titre_etape">3. Le jour J</h2>
        <span class="texte_etape">
          Je me présente à l’arrêt choisi au moins 3 minutes avant l’heure de départ. Je prépare mon titre de transport
          ou mon règlement au tarif en vigueur en prenant soin de faire l’appoint.
        </span>
      </div>
    </div>
  </b-container>
</template>

<script>
  export default {
    name: 'Reserver'
  }
</script>

<style lang="scss">
@import "src/sass/app";

.reserver {
  .titre {
    text-align: center;
    font-weight: bold;
    font-family: $titlefont;
    font-size: 50px;
    color: $secondcolor;
    margin: 3rem 0;
  }

  .accroche {
    margin: 2rem 0;
    font-size: 25px;
    text-align: justify;
    color: $annexecolor;
    font-family: $textfont;
    .telephone {
      color: $annexecolor;
    }
    .telephone:hover {
      color: $secondcolor;
      text-decoration: none;
    }
  }

  .bloc_comment_ca_marche {
    text-align: center;
    background-color: $secondcolor;
    border-radius: 15px;
    color: white;
    margin-bottom: 2rem;
    @include media-breakpoint-up(sm) {
      padding: 3rem;
    }
    @include media-breakpoint-down(xs) {
      margin: 0 0.1rem 2rem 0.1rem;
    }

    .etape {
      margin: 2rem 0;
      @include media-breakpoint-up(sm) {
        padding: 0 2rem;
      }
      @include media-breakpoint-down(sm) {
        margin: 2.5rem 0;
      }

      .icone {
        margin-bottom: 2rem;
      }

      .titre_etape {
        text-transform: uppercase;
        font-family: $titlefont;
        font-size: 30px;
        font-weight: bold;
      }

      .texte_etape {
        font-family: $textfont;
        font-size: 18px;
        text-align: justify;
        .lien {
          color: white;
          font-weight: bold;
          text-transform: uppercase;
          text-decoration: underline;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Reserver.vue